// Buffer polyfill — required by @solana/web3.js & spl-token, which assume a Node environment.
import { Buffer } from 'buffer';
(window as unknown as { Buffer: typeof Buffer }).Buffer = Buffer;

// IMPORTANT: Initialize Sentry BEFORE React
import { initSentry } from './config/sentry';
initSentry();

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { attemptStaleChunkReload } from './utils/lazyWithRetry'

if (import.meta.env.DEV) {
  try {
    sessionStorage.removeItem('cwy_chunk_refresh_attempts');
  } catch {
    /* ignore */
  }
}

// Dynamic import chunk failures (stale deploy, HTML fallback) often reject promises —
// especially Safari — so unhandledrejection must be handled alongside classic script errors.
window.addEventListener('unhandledrejection', (event) => {
  if (attemptStaleChunkReload(event.reason)) {
    event.preventDefault();
  }
});

// Script / modulepreload tags: MIME mismatch may surface here with a message string.
window.addEventListener(
  'error',
  (event) => {
    if (
      !(event.target instanceof HTMLScriptElement) &&
      !(event.target instanceof HTMLLinkElement && event.target.rel === 'modulepreload')
    ) {
      return;
    }
    const msg = event.message || '';
    if (msg && attemptStaleChunkReload(new Error(msg))) {
      event.preventDefault();
    }
  },
  true
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
